import type {DocumentManager} from '@wix/document-manager-core'
import type {AppsInstallStateExtAPI} from '../../../appsInstallState'
import type {MasterPageMigrator} from '../dataMigrationRunner'
import _ from 'lodash'

const version = 5

const migrateMasterPage = (documentManager: DocumentManager) => {
    const {extensionAPI, dal, logger} = documentManager

    logger.interactionStarted('migrateAppsStateToFragmentMigrator', {
        extras: {
            version
        }
    })

    const {appsInstallState} = extensionAPI as AppsInstallStateExtAPI
    const oldMasterPageState = dal.get(appsInstallState.getStateMapPointerFromMasterPage())

    // If I don't have fragment instance, I need to migrate the state from MasterPage to the fragment.
    const oldFragmentState = appsInstallState.getAllAppsInstallStatus()
    if ((!oldFragmentState || _.isEmpty(oldFragmentState)) && oldMasterPageState) {
        appsInstallState.migrateAppsStateToFragment()
    }

    logger.interactionEnded('migrateAppsStateToFragmentMigrator', {
        extras: {
            oldMasterPageState,
            oldFragmentState,
            version
        }
    })
}

const name = 'migrateAppsStateToFragment'

export const migrateAppsStateToFragment: MasterPageMigrator = {
    migrateMasterPage,
    name,
    version
}
